var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[(_vm.isStart)?_c('div',{staticClass:"top-left-cover-line"}):_vm._e(),(_vm.isEnd)?_c('div',{staticClass:"top-right-cover-line"}):_vm._e(),(_vm.isStart)?_c('div',{staticClass:"bottom-left-cover-line"}):_vm._e(),(_vm.isEnd)?_c('div',{staticClass:"bottom-right-cover-line"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }